<template>
  <div class="weui-search-box">
    <div class="weui-cell weui-cell_active">
      <div class="weui-cell__hd" v-if="label">
        <label for class="weui-label">{{label}}</label>
      </div>
      <div class="weui-cell__bd">
        <input
          :value="value"
          @input="onchange"
          @focus="focus"
          class="weui-input weui-search-box__input"
          :placeholder="placeholder"
          ref="input"
        />
      </div>
    </div>
    <div class="weui-cells weui-search-result" v-if="result && result.length">
      <div
        class="weui-cell weui-cell_active weui-cell_access"
        v-for="item in result"
        :key="item.display"
        @click="onSelect(item.value)"
      >
        <div class="weui-cell__bd">
          <p>
            {{item.value}}
          </p>
        </div>
        <div class="weui-cell__ft">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    placeholder: {
      type: String,
      default: "搜索",
    },
    value: String,
    url: String
  },
  data() {
    return {
      data: [],
      result: [],
      request: false
    };
  },
  methods: {
    resetResultList() {
      this.result = [];
    },
    focus() {
      var me = this
      if(!me.request) {
        me.$ajax({
          url: me.url,
        }).then(function (res) {
            me.data = res.data
            me.request = true
            me.result = me.data
        })
      }
      else {
        me.result = me.data
      }
    },
    onchange() {
      var me = this,
        val = me.$refs.input.value
      me.$emit("input", val)
      if (val) {
        if (this.$refs.input == document.activeElement) {
          this.search(val)
        }
      } else {
        this.resetResultList()
      }
    },
    search(val) {
      this.result = this.data.filter(item => { return item.value.indexOf(val) != -1 })
    },
    onSelect(value) {
      var me = this
      me.$refs.input.blur();
      me.$emit("input", value);
      me.resetResultList();
    },
  },
};
</script>

<style scoped>
.weui-search-result {
  background-color: #f8f8f8;
  max-height: 300px;
  overflow-y: auto;
}
.weui-search-box {
  position: relative;
}
.weui-search-box:before {
  content: " ";
  position: absolute;
  top: 0;
  left: 32px;
  right: 32px;
  height: 1px;
  color: rgba(0, 0, 0, 0.1);
  color: var(--weui-FG-3);
  z-index: 2;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-top: 1px solid var(--weui-FG-3);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
/* .weui-cell__bd p {
  color: var(--weui-FG-1);
} */
.weui-cells {
  background-color: var(--weui-BG-1);
}
</style>